module.exports = __webpack_public_path__ + "yt.svg?0f00b1036165d69eff29d5b898873ad8";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/yt.svg
// module id = 1445
// module chunks = 0